var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"columns":_vm.columns,"create-route":{
          name: 'taskRecurring.create'
      },"filters":_vm.filters,"pagination":true,"repository-func":_vm.repositoryFunc,"title":_vm.title,"identifier":"recurringTasksTable"},scopedSlots:_vm._u([{key:"task-status-template",fn:function({row}){return [_c('task-status',{attrs:{"status":row.status}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }